import { render, staticRenderFns } from "./FormProgress.vue?vue&type=template&id=6e6e947b"
import script from "./FormProgress.vue?vue&type=script&lang=js"
export * from "./FormProgress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BasicIconButton: require('/var/www/vhosts/anothercodeproject.eu/jgast.anothercodeproject.eu/components/basic/BasicIconButton.vue').default})
